@if (races) {
  <div class="row pt-2">
    <!-- RACES -->
    <div class="col-8">
      <table class="table table-striped table-smaller table-not-rounded">
        <caption class="caption-sm caption-rounded">
          <div class="row">
            <div class="col-md-10">{{lgTrad.RACEELE}}</div>
            <div class="col-md-2 text-right">
              @if (droitsAccess.write) {
                <add-button class="pr-2 tab-btn-roundadd" (click)="openAjouterRaces()"
                  />
              }
            </div>
          </div>
        </caption>
        <thead>
          <tr>
            <th>{{lgTrad.CODE}}</th>
            <th>{{lgTrad.NOM}}</th>
            <th>{{lgTrad.PRODUCTION}}</th>
            <th class="text-center">{{lgTrad.INUL}}</th>
            <th class="text-center">{{lgTrad.ATELIERLAIT}}</th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          @for (race of races; track race) {
            <tr>
              <ng-container>
                <td>{{race.RFRACE.CORABO}}</td>
                <td>{{race.RFRACE.LIRACE}}</td>
                <td>{{translate.instant("APPFICHECLIENT." + race.RFRACE.PRPRRA)}}</td>
                <td class="text-center">
                  <cp-icon-ul [presenceUl]="race.PRESENCEUL" />
                </td>
                <td class="text-center">
                  @if (raceSource(race,'GR')) {
                    <cp-icon-atelier (click)="switchAtelierRace(race)"
                      [presenceUl]="race.PRESENCEUL" [presenceAtelier]="race.ATLAIT" />
                  }
                  @if (!raceSource(race, 'GR')) {
                    <cp-icon-atelier-not-in-gala-race
                      (click)="enregistrerRaceDansGalaRace(race)" [presenceUl]="race.PRESENCEUL"
                      [presenceAtelier]="race.ATLAIT" />
                  }
                </td>
                <td>
                  <div class="btn-group w-100 justify-content-end">
                    @if (this.isAccessWrite() && raceSource(race,'GR' )) {
                      <gala-btn-delete
                        (click)="deleteRace(race)" />
                    }
                  </div>
                </td>
              </ng-container>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
